import { render } from "./ProjectCard.vue?vue&type=template&id=1f83540b&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=1f83540b&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f83540b"]])

export default __exports__